export default __webpack_public_path__ + "static/screeny-150-gpz-unica-1-ca9b101b1b6857dc42e4fc140c1f69b8.jpg";